import React from 'react'
import { getProjectInfo, deleteCustomField } from 'utils/CustomFieldUtils';
import { useAppContext } from 'hooks/useAppContext';
import Grid from 'components/Custom/Grid'
import SkeletonGrid from 'components/Shared/SkeletonGrid';
import { CustomField } from 'classes';


export default function CustomFieldGrid() {
  const columns = CustomField.columns.filter(col => col.title !== "WorkItemId" && col.title !== "WorkItemsStatusId" && col.title !== "WitypeId" )
  const { selectedProject } = useAppContext(); //Getting the App Context
  const title = "Custom Fields"
  const getFormPath = () => import('components/Details/CustomFieldsForm')

  return (
    <div style={{ paddingTop: '20px' }}>
      {selectedProject ?
        <Grid columns={columns} title={title} 
        getRecords={getProjectInfo}
        deleteRecord={deleteCustomField}
        selectedProject={selectedProject}
        component="CustomFields" formPath={getFormPath}
        options={{
          pageSize: 10,
          pageSizeOptions: [10, 15, 25]
        }}
        /> : <SkeletonGrid title={title} />
      }
    </div>
  )
}